import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles/index'
import Paper from 'material-ui/Paper'
import List from 'material-ui/List'
import Button from 'material-ui/Button'
import Table, {TablePagination, TableFooter, TableRow} from 'material-ui/Table'
import {appointments as styles} from '../styles'
import {appointments as text} from '../text'
import moment from '../../../common/moment'
import ErrorMessage from '../../../common/components/ErrorMessage'
import HeaderProgress from '../../../common/components/HeaderProgress'
import CancelAppointmentDialog from './cancelAppointmentDialog'
import ViewAppointmentDialog from './viewAppointmentDialog'
import withWidth from 'material-ui/utils/withWidth'
import compose from 'recompose/compose'

class Appointments extends React.Component {

  state = {
    page: 0,
    rowsPerPage: 10,
  }

  handleChangePage = (event, page) => {
    this.setState({page})
  }

  handleChangeRowsPerPage = event => {
    this.setState({rowsPerPage: event.target.value})
  }

  handleOnCancel = transaction => {
    this.props.setCancelDialogOpen(true)
  }

  closeCancelDialog = () => {
    this.props.setCancelDialogOpen(false)
  }

  closeViewDialog = () => {
    this.props.setViewDialogOpen(false)
  }

  openAppointmentDialog = (appointment) => {
    this.props.fetchTransaction(appointment.ID)
    this.props.setViewDialogOpen(true)
  }

  render() {
    const {classes, isLoading, error, openCancelDialog, openViewDialog, transaction, transactions, width} = this.props
    const {rowsPerPage, page} = this.state

    if (error !== '') return <ErrorMessage error={error}/>

    return (
      <div>
        <HeaderProgress show={isLoading}/>
        <CancelAppointmentDialog
          open={openCancelDialog}
          onClose={this.closeCancelDialog}
          onCancel={this.props.cancelAppointment}
          isLoading={isLoading}
        />
        <ViewAppointmentDialog
          open={openViewDialog}
          onClose={this.closeViewDialog}
          onCancel={this.handleOnCancel}
          isLoading={false}
          transaction={transaction}
        />
        <AppointmentsList
          classes={classes}
          list={transactions.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)}
          title={text.upcomingAppointments}
          button={
            <Button variant="flat" color="primary" onClick={this.props.startDeposit}>{text.scheduleAppointment}</Button>
          }
          showCancel={true}
          onCancel={this.handleOnCancel}
          width={width}
          isLoading={isLoading}
          openAppointmentDialog={this.openAppointmentDialog}
        />
        <Table>
          <TableFooter>
            <TableRow>
              <TablePagination
                count={transactions.size}
                onChangePage={this.handleChangePage}
                page={page}
                rowsPerPage={rowsPerPage}
                onChangeRowsPerPage={this.handleChangeRowsPerPage}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </div>
    )
  }

  static propTypes = {
    transaction: PropTypes.object,
    transactions: PropTypes.object.isRequired,
    startDeposit: PropTypes.func.isRequired,
    selectTransaction: PropTypes.func.isRequired,
    cancelAppointment: PropTypes.func.isRequired,
    setCancelDialogOpen: PropTypes.func.isRequired,
    setViewDialogOpen: PropTypes.func.isRequired,
    openCancelDialog: PropTypes.bool,
    openViewDialog: PropTypes.bool,
    isLoading: PropTypes.bool,
    error: PropTypes.string,
    width: PropTypes.string,
  }
}

class AppointmentsList extends React.Component {

  detailTitleByType = {
    1: 'Retiro', //de alquiler
    2: 'Envío', //de alquiler
    3: 'Retiro',
    4: 'Envío',
    5: 'Retiro',
  }

  titlesByType = {
    1: 'Retiro programado',
    2: 'Envío programado',
    3: 'Retiro programado',
    4: 'Envío programado',
    5: 'Retiro programado',
  }

  descriptionsByType = {
    1: 'Solicitaste un retiro', //de alquiler
    2: 'Solicitaste un envío', //de alquiler
    3: 'Solicitaste un retiro',
    4: 'Solicitaste un envío',
    5: 'Solicitaste un retiro',
  }

  titleByStatus = {
    1: 'En Curso',
    2: 'En Curso',
    3: 'En Curso',
    4: 'Concretado',
    5: 'Con errores',
    6: 'Cancelado',
    7: 'Concretado',
    8: 'Concretado',
    9: 'En Curso',
  }

  render() {
    const {classes, list, isLoading} = this.props
    return (
      <div style={{minHeight: 520}}>
        {list.size === 0 && !isLoading && <NoAppointments classes={classes}/>}
        <List style={{marginTop: 35}}>
          {list.map((appointment, key) =>
            <Paper
              key={key}
              className={classes.appointmentContainer}
              onClick={() => this.props.openAppointmentDialog(appointment)}
            >
              {this.renderAppointmentStatus(appointment, classes)}
            </Paper>,
          )}
        </List>
      </div>
    )
  }

  renderAppointmentStatus = (appointment, classes) => {
    const itemMoment = moment.utc(appointment.ReserveDate).utcOffset(moment().utcOffset(), true)
    const isCancelled = appointment.TransactionStatus.ID === 6
    const isDone = appointment.TransactionStatus.ID === 4
      || appointment.TransactionStatus.ID === 8
      || appointment.TransactionStatus.ID === 7
    const isWithError = appointment.TransactionStatus.ID === 5
    const isUpcoming = itemMoment.isAfter()
    // const date = itemMoment.format('D MMMM YYYY')

    // const canCancel = isUpcoming && (!isCancelled && !isWithError && !isDone)

    let statusText = ''
    let description = ''
    let statusColor = ''

    if (isCancelled) {
      statusText = this.titleByStatus[appointment.TransactionStatus.ID]
      description = this.descriptionsByType[appointment.TransactionType.ID]
      statusColor = '#FF4378' // Pink
    } else if (isDone) {
      statusText = this.titleByStatus[appointment.TransactionStatus.ID]
      description = this.descriptionsByType[appointment.TransactionType.ID]
      statusColor = '#5d58f7' // Primary 500
    } else if (isWithError) {
      statusText = this.titleByStatus[appointment.TransactionStatus.ID]
      description = this.descriptionsByType[appointment.TransactionType.ID]
      statusColor = '#FF4378' // Pink
    } else if (isUpcoming) {
      statusText = this.titlesByType[appointment.TransactionType.ID]
      description = this.descriptionsByType[appointment.TransactionType.ID]
        + ` para el ${itemMoment.format('D')} de ${itemMoment.format('MMMM')}`
        + (itemMoment.format('h') === '1' ? ' a la ' : ' a las ')
        + itemMoment.format('h:mm A')
      statusColor = '#5d58f7' // Primary 500
    } else {
      statusText = this.titleByStatus[appointment.TransactionStatus.ID]
      description = this.descriptionsByType[appointment.TransactionType.ID]
      statusColor = '#5d58f7' // Primary 500
    }

    return (
      <div>
        <p className={classes.appointmentStatus} style={{color: statusColor}}>{statusText}</p>
        <p className={classes.appointmentDescription}>{description}</p>
        <p className={classes.appointmentDate}>{moment(appointment.ReserveDate).format('DD MMMM YYYY')}</p>
      </div>
    )
  }
}

class NoAppointments extends React.Component {
  render() {
    const noAppointmentsImagePath = '/assets/noActivities.png'

    return (
      <div className={this.props.classes.noAppointmentsContainer}>
        <img src={noAppointmentsImagePath} className={this.props.classes.noAppointmentsImage} alt={'no appointments'}/>
        <p className={this.props.classes.noAppointmentsTitle}>{text.noAppointmentsTitle}</p>
        <p className={this.props.classes.noAppointmentsSubtitle}>{text.noAppointmentsSubtitle}</p>
      </div>
    )
  }
}

export default compose(withStyles(styles, {withTheme: true}), withWidth())(Appointments)



// WEBPACK FOOTER //
// ./src/sections/activity/components/appointments.js